import {Platform, View} from 'react-native';
import {Field} from 'redux-form';
import {ReduxVisuallyImpairedRadio} from '../radio';
import {fontSizes, fontTypes, intervals} from '../../../constants/visuallyImpairedValues';
import {ReduxVisuallyImpairedColor} from '../colorControl';
import {ReduxVisuallyImpairedSwitch} from '../switch';
import React from 'react';
import {Props} from './model';
import {useStyles} from '../../../hooks/styles';

export default (props: Props) => {
  const styles = useStyles(() => ({
    fieldWrapper: {
      marginBottom: 36,
    },
  }));
  return (
    <View>
      <View style={[styles.fieldWrapper, props.groupStyle]}>
        <Field name='fontSize' component={ReduxVisuallyImpairedRadio} label='Размер шрифта' items={fontSizes} />
      </View>
      <View style={[styles.fieldWrapper, props.groupStyle]}>
        <Field
          name='switchColor'
          component={ReduxVisuallyImpairedColor}
          label={Platform.OS === 'web' ? 'Цвет сайта' : 'Цвет приложения'}
        />
      </View>
      <View style={[styles.fieldWrapper, props.groupStyle]}>
        <Field name='switchImages' component={ReduxVisuallyImpairedSwitch} label='Изображения' />
      </View>
      <View style={[styles.fieldWrapper, props.groupStyle]}>
        <Field name='letterSpacing' component={ReduxVisuallyImpairedRadio} label='Интервал' items={intervals} />
      </View>
      <View style={[styles.fieldWrapper, props.groupStyle]}>
        <Field name='fontStyle' component={ReduxVisuallyImpairedRadio} label='Шрифт' items={fontTypes} />
      </View>
    </View>
  );
};
